import { customerName, ownerLabel } from "../lib/format.js";

export function CustomerLink({ customerId, customers = [], fallbackName = "", customer, openCustomer, children }) {
  const targetCustomer = customer || customers.find((item) => item.id === customerId);
  const label = children || targetCustomer?.name || displayCustomerName(customers, customerId, fallbackName);
  if (!openCustomer || (!targetCustomer && !customerId)) return label || "-";
  return (
    <a
      className="table-link-btn"
      href="#"
      title={`Open ${label || "prospect"}`}
      onClick={(event) => {
        event.preventDefault();
        openCustomer(targetCustomer || customerId);
      }}
    >
      {label || "-"}
    </a>
  );
}

export function EmployeeLink({ userId, users = [], openEmployee, fallback = "-" }) {
  const label = ownerLabel(users, userId);
  if (!openEmployee || !userId) return label || fallback;
  return (
    <button className="table-link-btn" type="button" onClick={() => openEmployee(userId)}>
      {label || fallback}
    </button>
  );
}

export function displayCustomerName(customers, customerId, fallbackName = "") {
  if (!customerId) return fallbackName || "-";
  const name = customerName(customers, customerId);
  return name === customerId ? fallbackName || name : name;
}
